import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentCart } from '@cargos/sprintpay-models';
import { ConfigService } from 'src/app/shared/services';

@Component({
    selector: 'app-cart-payment-details-card',
    templateUrl: './cart-payment-details-card.component.html',
    styleUrl: './cart-payment-details-card.component.scss',
    standalone: false,
})
export class CartPaymentDetailsCardComponent implements OnInit {
    public facilityName: string | undefined;
    public panelOpenState = false;
    public labelAWB: string = '';
    @Input() paymentRequest: PaymentCart;
    @Input() labelByPanel: string = '';
    @Input() cartSplitByAwbAndFlight: boolean = false;
    @Input() set first(value: boolean) {
        this.panelOpenState = value;
    }
    @Output() removePaymentById = new EventEmitter<number>();
    @Output() editPayment = new EventEmitter<PaymentCart>();

    constructor(private configService: ConfigService) {}

    ngOnInit(): void {
        this.facilityName = this.getFacilityName();
        this.getLabelsConfig();
    }

    getFacilityName(): string | undefined {
        return this.paymentRequest.facility?.name;
    }

    removePayment(paymentId: number): void {
        this.removePaymentById.emit(paymentId);
    }

    editPaymentRequest(payment: PaymentCart): void {
        this.editPayment.emit(payment);
    }

    getLabelsConfig(): void {
        this.labelAWB = this.configService.getLabelAWB();
    }
}
